<template>
  <el-dialog
    title="保存模版"
    :visible.sync="dialogVisible"
    width="600px"
    @open="handleOpen"
  >
    <el-form ref="savaTmpForm" :model="form" :rules="rules">
      <el-form-item label="标题" prop="title" label-width="60px">
        <el-input v-model="form.title" placeholder="请输入标题名称"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="saveTempalte">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      form: {
        title: ''
      },
      rules: {
        title: {required: true, message:'请输入标题名称', trigger: 'blur'}
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(newVal) {
        this.$emit('update:visible', newVal)
      }
    }
  },
  methods: {
    handleOpen() {
      this.$refs.savaTmpForm?.resetFields();
    },
    saveTempalte() {
      this.$refs.savaTmpForm.validate(valid => {
        if (!valid) return
        this.$emit('save', this.form.title);
        this.close();
      })
    },
    close() {
      this.dialogVisible = false
    }
  },
}
</script>

<style>

</style>